export const dateFunction = (isoDate: any) => {
    const date = new Date(isoDate);
    // Format to only include the date
    const readableDate = date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long', // e.g., "July"
      day: 'numeric',
    });
    return readableDate;
  };